export const _arrayPesquisadoresHomologacao =
[
    '0CE23C9A-1825-43A6-8ED3-3F1D2F426C86', //limarj23 servidor
    '088B1BAD-9892-4849-9E1A-119533A39EDA', //andimarj, servidor
    '09D63C20-1903-43C2-A0A3-2C38983DB92E', //evelyn.silva98es@gmail.com, servidor
    'A5DD3423-354A-4F53-92FF-60569B3A0A91', //thaysnascimento.souza@gmail.com, servidor
    '34B31CDA-484C-4D5F-80E3-F92F7020E4A2', //nzitske@gmail.com, servidor
    '20A9D7D3-0FAD-4943-ACE4-8DB01662B72F', //marilia.tokiko@usp.br, servidor
    '8F40986C-3C29-4085-9FF7-AA22E18B604B', //beatriztorquato@usp.br, servidor
    '284992D7-31DE-4409-AA09-D3FE4CD94F62', //ktgabe.nutri@gmail.com, servidor
    '0EA49E45-373F-4EB2-9EC1-4956187B7C8D',  //catalinaserrano@usp.br, servidor
    '93005EE0-282E-47ED-BA3C-9F1E208D8831'  //dsmarques.thais@gmail.com, servidor
]


